export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="3" viewBox="0 0 13 3">
            <path d="M1.092 2.295h11.016c.26 0 .474-.074.641-.223A.732.732 0 0 0 13 1.5a.732.732 0 0 0-.251-.572.928.928 0 0 0-.641-.223H1.092a.928.928 0 0 0-.641.223A.732.732 0 0 0 .2 1.5c0 .232.084.423.251.572.167.149.381.223.641.223z" fill="currentColor" />
        </svg>
    );
}
